export const SUPER_SEARCH_TEST_IDS = {
  broaden: 'super-search__broaden',
  clear: 'super-search__clear',
  clearHistory: 'super-search__clear-history',
  dialog: 'super-search__dialog',
  empty: 'super-search__empty',
  error: 'super-search__error',
  input: 'super-search__input',
  instructions: 'super-search__instructions',
  loading: 'super-search__loading',
  loadingState: 'super-search__loading-state',
  navigation: 'super-search__navigation',
  result: (resultId: string) => `super-search__result-${resultId}`,
  results: 'super-search__results',
  retry: 'super-search__retry',
  sectionLabel: (sectionId: string) => `super-search__section-${sectionId}`,
  status: 'super-search__status',
} as const;
